import CustomProperty from "./Modules/CustomProperty.js";

CustomProperty();
const wrapper = document.getElementById("js-scrollCube");
const main = wrapper.querySelector(".js-main");
const sub = wrapper.querySelector(".js-sub");

const children = main.children;

for(const child of children) {
  const clone = child.cloneNode(true);
  clone.classList.add('is-clone');
  sub.appendChild(clone);
}


let prevent = false;

const scrollSync = (leader, follower) => {
  prevent = !prevent;
  if (prevent) return;
  follower.scrollTop = leader.scrollTop; 
}

main.addEventListener("scroll", scrollSync.bind(null, main, sub));
sub.addEventListener("scroll", scrollSync.bind(null, sub, main));